import React from 'react';
import { Form } from 'react-final-form';
import moment from 'moment';

import { CircleIcon } from '@zola/zola-ui';
import { Calendar } from '@zola/zola-ui/src/assets/images/icons';

import css from 'stylesheets/common/_modal.module.less';
import DateForm from './WeddingDateForm';

const formatDate = data => {
  const { wedding_date: date } = data;
  return moment(date).format('YYYY-MM-DD');
};

const WeddingDateModal = ({ wedding, publishSite, updateWedding }) => {
  const updateData = data => {
    return Object.assign({}, wedding, { wedding_date: formatDate(data) });
  };
  const onSubmit = data => {
    const { wedding_date: weddingDate } = data;
    return weddingDate !== ''
      ? updateWedding(updateData(data)).then(() => publishSite())
      : publishSite();
  };

  return (
    <div className={`wedding-date__modal ${css.container}`}>
      <CircleIcon image={Calendar} variant="cream" size={100} className="circleIcon" />
      <h3 className={css.title}>
        Add your wedding date so guests can see it on your site. You can do this later, too (and
        change it anytime).
      </h3>
      <Form onSubmit={onSubmit} render={DateForm} initialValues={{ wedding_date: '' }} />
    </div>
  );
};

export default WeddingDateModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/WeddingDateModal/WeddingDateModal.jsx